module.exports = __webpack_public_path__ + "681779f94c4de90bf71bf70e4401a22f.png";


//////////////////
// WEBPACK FOOTER
// ./content/help/research/insilico/scoring-img/img9.png
// module id = 1328
// module chunks = 0